import { createGlobalStyle } from 'styled-components';
import { responsive } from '../helpers/styledHelper';
import regular from '../assets/fonts/inter/Inter-Regular.ttf';
import thin from '../assets/fonts/inter/Inter-Thin.ttf';
import bold from '../assets/fonts/inter/Inter-Bold.ttf';
import black from '../assets/fonts/inter/Inter-Black.ttf';
import medium from '../assets/fonts/inter/Inter-Medium.ttf';
import semibold from '../assets/fonts/inter/Inter-SemiBold.ttf';
import light from '../assets/fonts/inter/Inter-Light.ttf';
import extralight from '../assets/fonts/inter/Inter-ExtraLight.ttf';
import extrabold from '../assets/fonts/inter/Inter-ExtraBold.ttf';

const fontFaces = {
  'Inter Regular': regular,
  'Inter Thin': thin,
  'Inter Bold': bold,
  'Inter Black': black,
  'Inter Medium': medium,
  'Inter Semi Bold': semibold,
  'Inter Light': light,
  'Inter Extra Light': extralight,
  'Inter Extra Bold': extrabold
};

const fontFamily = Object.entries(fontFaces)
  .map(
    ([fontName, url]) => `
  @font-face {
    font-family: '${fontName}';
    src: url('${url}');
  }
`
  )
  .join(' ');

export const GlobalStyles = createGlobalStyle`
 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* overflow-x: hidden; */
  }

  ${fontFamily}

  /* @font-face {
    font-family: 'Inter';
    src: url('${regular}');
  }

  @font-face {
    font-family: 'Inter Bold';
    src: url('${bold}');
  } */

  body{
    font-family: Inter Regular;
    scroll-behavior: smooth;
  }

  :root {
      font-size: ${responsive(24)};

      @media (min-width: 768px) {
        font-size: ${responsive(18)};
      }

      @media (min-width: 1440px) {
        font-size: ${responsive(16)};
      }
    }

  /* #root {
    overflow-x: hidden;
  } */
`;
